import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Box, Typography, IconButton, InputAdornment } from '@mui/material';

import { DialogUI, InputUI } from '../Interface';
import { formatNumber } from '../../utils/currencyHelper';

const ItemsDialog = ({ open, handleClose, items, addItem, itemFilter, setItemFilter, isSearching }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Találatok'}
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', height: '70vh' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      <Box sx={{ mt: 1, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flex: 1, bgcolor: 'white' }}>
          <InputUI
            autoFocus
            fullWidth
            size="small"
            type="search"
            placeholder="Cikknév/cikkszám"
            value={itemFilter}
            onChange={(e) => setItemFilter(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" edge="end" aria-label="Keresés" disabled>
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      {!String(itemFilter || '').trim() ? (
        <Box>Kezdje el a keresést.</Box>
      ) : isSearching ? (
        <Box>Keresés...</Box>
      ) : items?.length === 0 ? (
        <Box>Nincs találat.</Box>
      ) : (
        <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {items?.map((evt) => {
            const { itemCode, itemName } = evt;

            return (
              <Box
                key={`${itemCode}`}
                onClick={() => {
                  addItem(evt);
                  handleClose();
                }}
                sx={{
                  px: 1.5,
                  py: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                  {itemCode} - {itemName}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Elérhető mennyiség:
                  </Box>{' '}
                  {formatNumber(parseFloat(evt.sumQuantity ?? 0))} {evt.quantityUnit?.code || ''}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </DialogUI>
  );
};

export default ItemsDialog;
